import {createBaseShape} from './createBaseShape'

export const createRect = (attrs) => {
  let strokeSize = 2
  let strokeColor = 'black'
  let fillColor = attrs.fill
  let dash
  let lineCap

  if (window.applyAllStyle) {
    if (typeof window.strokeSize !== 'undefined') {
      strokeSize = window.strokeSize
    }

    if (typeof window.strokeColor !== 'undefined') {
      strokeColor = window.strokeColor
    }

    if (typeof window.lineType !== 'undefined') {
      dash = window.lineType[0]
      lineCap = window.lineType[1]
    }

    if (typeof window.fillColor !== 'undefined') {
      fillColor = window.fillColor
    }
  }

  return Object.assign(createBaseShape(attrs), {
    width: 100,
    height: 100,
    stroke: strokeColor,
    strokeWidth: strokeSize,
    fill: fillColor,
    dash: dash,
    lineCap: lineCap,
    name: 'rectangle'
  })
}



// WEBPACK FOOTER //
// ./src/components/schemaFonctionnel/helper/createRect.js